import { notification } from "antd";
import { NotificationTypes } from "../../common/Constants";

export interface INotificationService {
  showError(messageText: string): void;
  showSuccess(messageText: string): void;
  showWarning(messageText: string): void;
  showInfo(messageText: string): void;
}

const DURATION_MESSAGE = 4;

const NotificationService = ({ translationService }): INotificationService => {
  const showMessage = (messageText: string, type: string) => {
    const method = notification[type];
    method({
      message: translationService.get(`notifications.${type}`),
      description: messageText,
      duration: DURATION_MESSAGE
    });
  };

  return {
    showError(messageText: string) {
      showMessage(messageText, NotificationTypes.ERROR);
    },
    showSuccess(messageText: string) {
      showMessage(messageText, NotificationTypes.SUCCESS);
    },
    showWarning(messageText: string) {
      showMessage(messageText, NotificationTypes.WARNNING);
    },
    showInfo(messageText: string) {
      showMessage(messageText, NotificationTypes.INFO);
    }
  };
};

export default NotificationService;
